module.exports = __webpack_public_path__ + "static/media/salao_atico_3.818ccb27.jpg";